/**
 * Environment Configuration
 * Centralized configuration for different environments
 */

const config = {
    // API Configuration
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api',

    // Environment
    NODE_ENV: process.env.NODE_ENV,
    REACT_APP_ENV: process.env.REACT_APP_ENV,

    // Firebase Configuration
    FIREBASE: {
        API_KEY: process.env.REACT_APP_FIREBASE_API_KEY,
        AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
        PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID,
        STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
        MESSAGING_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
        APP_ID: process.env.REACT_APP_FIREBASE_APP_ID,
    },

    // Named Firestore DB for chat (must match backend CHAT_FIRESTORE_DATABASE_ID)
    CHAT_FIRESTORE_DATABASE_ID: process.env.REACT_APP_CHAT_FIRESTORE_DATABASE_ID || '',

    // Google Drive Picker (optional — upload from Drive in the browser)
    GOOGLE_DRIVE: {
        CLIENT_ID: process.env.REACT_APP_GOOGLE_DRIVE_CLIENT_ID || '',
        API_KEY: process.env.REACT_APP_GOOGLE_DRIVE_API_KEY || '',
        APP_ID: process.env.REACT_APP_GOOGLE_DRIVE_APP_ID || '',
    },

    // Debug information
    DEBUG: process.env.NODE_ENV === 'development',
};

// Log configuration in development
if (config.DEBUG) {
    console.log('🔧 Environment Configuration:', {
        API_BASE_URL: config.API_BASE_URL,
        NODE_ENV: config.NODE_ENV,
        REACT_APP_ENV: config.REACT_APP_ENV,
    });
}

export default config;
